import { Directive, HostListener } from '@angular/core';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[humanNamesChecker]',
  standalone: false
})
export class HumanNamesDirective {

  private regex: RegExp = /^[a-zA-Z .'-]+$/;

  constructor(private commonServices: CommonServices) { }

  // Typing check
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);

    if (!this.regex.test(inputChar)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only letters allowed in name', 2);
    }
  }

  // Paste check
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') || '';

    if (!this.regex.test(pastedText)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Name cannot contain numbers or special characters', 2);
    }
  }
}